import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { NoSearchResultsIcon } from "@features/no-search-results-icon";
import { ImageEmpty } from "@mzc-cloudplex/icons";
import theme from "@styles/theme";

const InvalidURL = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    return (
        <div className={"content-wrapper error-page"}>
            <div className={"card-body"}>
                <NoSearchResultsIcon
                    title={"URL not found"}
                    subTitle={"The URL has been deleted or the menu does not exist."}
                    icon={<ImageEmpty width={80} height={72} sx={{ marginBottom: 2.5 }} />}
                    titleProps={{
                        paddingBottom: 1,
                        color: theme.palette.greySecondary.main,
                        variant: "subtitle1_700",
                    }}
                />
            </div>
        </div>
    );
};
export default InvalidURL;
